import React from "react";
import AdminCard from "./adminCard";
import "./rejected.css";

const Rejected = ({ ordersFound, data, handleStatusClick, handleDeliveryClick, OrderTrackerResponse, handleChef, handleComment, handleRefund }) => {
  const handleOrder = (orderID) => {
    window.open(`/order?orderID=${orderID}`, "_blank");
  };

  return (
    <div className="rejected">
      {ordersFound ? (
        data.map((data, id) => (
          <AdminCard
            id={id}
            data={data}
            handleOrder={handleOrder}
            status="REJECTED"
            handleChef={handleChef}
            handleStatusClick={handleStatusClick}
            handleDeliveryClick={handleDeliveryClick}
            OrderTrackerResponse={OrderTrackerResponse}
            handleComment={handleComment}
            handleRefund={handleRefund}
          />
        ))
      ) : (
        <h1>No Rejected orders</h1>
      )}
    </div>
  );
};

export default Rejected;
